"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MasterOfTheCraft() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const figures = [{
    src: "https://better-malamute.10web.cloud/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-09-at-14.01.08.jpeg?v=rxce399lzxh",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698889/img/f2ae1f5c-53f7-4ebe-bccb-9f98e624f319.webp",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698889/img/f2ae1f5c-53f7-4ebe-bccb-9f98e624f319.webp",
    alt: "George, the master artist at Hard Rock Tattoo",
    caption: "FIG. 01 — THE ARTIST",
    offset: "md:ml-0 md:mr-12"
  }, {
    src: "https://better-malamute.10web.cloud/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-09-at-12.44.48.jpeg?v=m0y2yllpvma",
    srcset: "https://better-malamute.10web.cloud/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-09-at-12.44.48.jpeg?v=w0xfjrljpl-wvc-srcset",
    sizes: "https://better-malamute.10web.cloud/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-09-at-12.44.48.jpeg?v=vjd0agdcddl-wvc-sizes",
    alt: "Daniella, resident artist at Hard Rock Tattoo",
    caption: "FIG. 02 — THE ARTIST",
    offset: "md:ml-8 md:mr-4"
  }, {
    src: "https://hardrocktatto.com/wp-content/uploads/2026/06/5becc885-f06b-4e4a-b4a3-c95808d5198e.png?v=vpfzne03kua",
    srcset: "https://hardrocktatto.com/wp-content/uploads/2026/06/5becc885-f06b-4e4a-b4a3-c95808d5198e.png?v=6gzid9lfqyh",
    sizes: "https://hardrocktatto.com/wp-content/uploads/2026/06/5becc885-f06b-4e4a-b4a3-c95808d5198e.png?v=07lbu62za58i",
    alt: "Close up of a professional tattoo machine in a dark studio",
    caption: "FIG. 03 — THE INSTRUMENT",
    offset: "md:ml-16 md:mr-0"
  }, {
    src: "https://better-malamute.10web.cloud/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-09-at-14.47.33.jpeg?v=7wx9i556a0x",
    srcset: "https://better-malamute.10web.cloud/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-09-at-12.44.48.jpeg?v=w0xfjrljpl-wvc-srcset",
    sizes: "https://better-malamute.10web.cloud/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-09-at-12.44.48.jpeg?v=vjd0agdcddl-wvc-sizes",
    alt: "Daniella, resident artist at Hard Rock Tattoo",
    caption: "FIG. 04 — THE ARTIST AT WORK",
    offset: "md:ml-4 md:mr-20"
  }];
  return <section data-section-id="3233" id="master-of-the-craft" className="bg-background text-foreground py-24 md:py-32 lg:py-44 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-20">
          {}
          <div ref={leftRef} className={`lg:col-span-7 transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="flex items-center gap-3 mb-12 md:mb-16">
              <span className="h-px w-10 bg-primary" aria-hidden="true" />
              <p className="font-mono text-[11px] md:text-xs uppercase tracking-[0.2em] text-primary">
                — The Artists / George &amp; Daniella
              </p>
            </div>

            {}
            <h2 className="font-default font-bold text-foreground leading-[0.9] tracking-tighter" style={{
            fontSize: "clamp(2.5rem, 6vw, 5.5rem)"
          }}>
              Where ink becomes a{" "}
              <em className="italic font-normal" style={{
              color: "var(--primary)"
            }}>
                legacy
              </em>
              <br />
              — not just a{" "}
              <span className="relative inline-block">
                <span className="relative z-10">mark</span>
                <span className="absolute left-0 right-0 top-1/2 h-[2px] bg-primary -translate-y-1/2" aria-hidden="true" />
              </span>
              <br />
              on skin.
            </h2>

            {}
            <div className="mt-12 md:mt-16 max-w-xl space-y-6">
              <p className="font-default text-base md:text-lg leading-relaxed text-foreground/90">
                Hard Rock Tattoo is the premier destination for those seeking the extraordinary in Paphos. Led by George and Daniella, our studio is a sanctuary where luxury meets rock and roll, dedicated to the craft of permanent storytelling through bold, gothic-inspired artistry.
              </p>
              <p className="font-default text-base md:text-lg leading-relaxed text-foreground/90">
                Every piece is a collaboration—a meticulous translation of your vision into a masterpiece of shadow and light. We don't just follow trends; we forge legends, ensuring each needle stroke carries the weight of intention and the precision of a master.
              </p>
            </div>

            {}
            <div className="mt-16 md:mt-20 flex flex-wrap items-end gap-12 md:gap-16">
              <div>
                <p className="font-default italic text-3xl md:text-4xl text-foreground" style={{
                fontFamily: "var(--font-serif)"
              }}>
                  George
                </p>
                <p className="font-mono text-[10px] md:text-[11px] uppercase tracking-[0.22em] text-muted-foreground mt-3">
                  Master Artist &amp; Founder · Hard Rock Tattoo Paphos
                </p>
              </div>
              <div>
                <p className="font-default italic text-3xl md:text-4xl text-foreground" style={{
                fontFamily: "var(--font-serif)"
              }}>
                  Daniella
                </p>
                <p className="font-mono text-[10px] md:text-[11px] uppercase tracking-[0.22em] text-muted-foreground mt-3">
                  Resident Artist · Hard Rock Tattoo Paphos
                </p>
              </div>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`lg:col-span-5 transition-all duration-1000 ease-out delay-150 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="flex flex-col gap-10 md:gap-14">
              {figures.map((fig, i) => <figure data-index={i} key={i} className={`${fig.offset} group`}>
                  <div className="relative border border-border p-2 bg-card shadow-lg transition-shadow duration-500 group-hover:shadow-3xl" style={{
                height: '500px'
              }}>
                    <img src={fig.src} data-wvc-srcset={fig.srcset} data-wvc-sizes={fig.sizes} alt={fig.alt} loading="lazy" decoding="async" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" />
                  </div>
                  <figcaption className="mt-4 flex items-center gap-3">
                    <span className="h-px w-6 bg-primary" aria-hidden="true" />
                    <span className="font-mono text-[10px] md:text-[11px] uppercase tracking-[0.22em] text-muted-foreground">
                      {fig.caption}
                    </span>
                  </figcaption>
                </figure>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}